import { imgSbankSbankAppBg } from "@/shared/assets/img";
import { CheckIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";
import { BankTariffSelect } from "@/domains/bank/components/BankTariffSelect";
import { OnboardingFrame } from "@/domains/bank/components/Onboarding/OnboardingFrame";
import { Tariff } from "@/domains/bank/types";

export function OnboardingStep02({
  onSubmit,
  onCancel,
  tariffs,
  selectedTariffId,
  onTariffSelect,
}: {
  onSubmit: () => void;
  onCancel: () => void;
  tariffs: Tariff[];
  selectedTariffId?: number;
  onTariffSelect: (id: number) => void;
}) {
  return (
    <OnboardingFrame
      className="flex flex-col justify-between"
      style={{
        backgroundImage: `url(${imgSbankSbankAppBg})`,
      }}
    >
      <div className="flex flex-col justify-between">
        {/* Welcome text */}
        <div className="flex flex-col gap-1">
          <h3 className="text-20 font-bold text-sbank">Тарифные планы</h3>

          <p className="font-normal leading-tight">
            Вы можете выбрать тарифный план, который предоставляет нужные условия.
          </p>
        </div>
      </div>

      <BankTariffSelect tariffs={tariffs} value={selectedTariffId} onChange={onTariffSelect} />

      <div className="flex gap-4">
        <Button
          variant="solid-gradient"
          data-mz-accent="success"
          className="w-[220px] gap-2"
          onClick={onSubmit}
        >
          <CheckIcon className="shrink-0 size-4" />
          Выбрать тариф
        </Button>

        <Button
          variant="solid-outline"
          data-mz-accent="success"
          className="w-[120px] bg-[#21a0381a] text-sbank border-none hover:bg-[#21a0381a]/12"
          onClick={onCancel}
        >
          Назад
        </Button>
      </div>
    </OnboardingFrame>
  );
}
